export default __webpack_public_path__ + "static/media/887.3331c95a.jpg";